
<script lang="ts">

// Using @keyup.prevent.stop.capture="changed" allows us to get the
// correct character count from keyup, whereas keypress lags one behind
// until the field is blurred and @change picks up the last char.
// We always prevent default on it to keep from allowing typing over the limit.

import { stripHTML } from '@/utils'
import LinkifyingFormatter from '@/utils/linkifying-formatter'
import { normalizeTextarea } from '@/utils/sms-text'
import { onMount } from 'svelte'

let {
  id = '',
  disabled = false,
  value = $bindable(''),
  placeholder = 'Type here',
  classNames = '',
  coupon = {},
  hasImages = false,
  hasUpdateLink = false,
  numReservedChars = 0,
  autofocus = false,
  children = null
} = $props()

let inheritAttrs = $state(false)
let currentLength = $state(0)
let maxChars = $state(160)

let couponUrl = $derived(coupon?.shortened_url)
let hasCoupon = $derived(coupon?.id)

let textarea

onMount(() => {
  window.setTimeout(() => {
    changed()

    if (autofocus) {
      textarea?.focus()
    }
  }, 100)
})

function changed(evt) {
  // console.log('changed, evt: ', evt)
  // App.log('in changed, hasUpdateLink? ', hasUpdateLink)

  evt?.stopPropagation()

  if (evt && evt.key.match(/delete|backspace/i)) {
    return true
  }

  let formatter = new LinkifyingFormatter(value, {
    couponUrl: couponUrl,
    hasImages: hasImages,
    hasUpdateLink: hasUpdateLink,
    maxLength: maxChars
  })
  let formattedText = formatter.formattedText()
  // App.log("in changed, formattedText: -->" + formattedText + "<--")

  setCurrentLength(formattedText)
  setMaxLength(value)

  if (evt && !withinBounds()) {
    evt.preventDefault()
  }
}

// Swap smart punctuation for plain characters as the user types or pastes,
// so one curly quote doesn't drop the limit from 160 to 70
function normalized() {
  if (normalizeTextarea(textarea)) {
    value = textarea.value
  }
}

function setCurrentLength(formattedText) {
  let txt = stripHTML(formattedText)
  let length = txt.length
  // App.log('setCurrentLength, initial length: ', length)
  // App.log('  formattedText? ', formattedText)
  // App.log('  raw txt :', txt)
  // App.log('  has_coupon? ', hasCoupon)
  // App.log('  has_images? ', hasImages)
  // App.log('  hasUpdateLink? ', hasUpdateLink)

  if (length) {
    // add 2 to coupon for the prepended newline
    if (hasCoupon) {
      length += 2
    }

    // For the newline again
    if (hasUpdateLink) {
      length += 2
    }
  }

  // App.log('  final length: ', length)
  currentLength = length
}

function setMaxLength(text) {
  maxChars = App.message_modal_counter.max_chars(text) - numReservedChars
}

function withinBounds() {
  return (currentLength < maxChars)
}

$effect(() => {
  // triggers when any property changes
  $state.snapshot(coupon)
  hasImages
  hasUpdateLink
  numReservedChars
  // console.log('coupon changed: ', coupon)
  // console.log('hasImages changed: ', hasImages)
  // console.log('hasUpdateLink changed: ', hasUpdateLink)
  // console.log('numReservedChars changed: ', numReservedChars)
  changed()
})

</script>


<div class="LinkifyingTextarea">
    <textarea class="form-control {classNames}"
              {id}
              {disabled}
              bind:value={value}
              {placeholder}
              oninput={normalized}
              onkeypress={changed}
              onkeyupcapture={changed}
              onchange={changed}
              bind:this={textarea}
    ></textarea>
  <div class="textarea-counter-container">
    {@render children?.()}

    <span class="textarea-counter textarea-counter--bottom">
        {currentLength} / {maxChars}
      </span>
  </div>
</div>
